import React from 'react';
import styled from 'styled-components';
import ButtonWrapper from 'components/table/ActionButton/ButtonItem/ButtonWrapper';

interface IProps {
  menu: any;
}

const ButtonItem: React.FC<IProps> = ({ menu }) => {
  return (
    <>
      <MenuWrapper>
        {menu?.map((e, i) => (
          <ButtonWrapper key={i} color={e.color} hoverColor={e.hoverColor}>
            {e.item}
          </ButtonWrapper>
        ))}
      </MenuWrapper>
    </>
  );
};

export default ButtonItem;

const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 16px;
  }
`;
